"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxCreateReplyDraftArgs = void 0;
var HxDraftBody_1 = require("./HxDraftBody");
function serializeHxCreateReplyDraftArgs(_arg) {
    var output = [];
    output.push(_arg.subject);
    output.push(HxDraftBody_1.serializeHxDraftBody(_arg.draftBody));
    output.push(_arg.draftMessageHeaderId !== undefined);
    if (_arg.draftMessageHeaderId !== undefined) {
        output.push(_arg.draftMessageHeaderId.toString());
    }
    return output;
}
exports.serializeHxCreateReplyDraftArgs = serializeHxCreateReplyDraftArgs;
